export const externalContactTopicName = (contactId?: string) => contactId
  ? `v2.externalcontacts.contacts.${contactId}`
  : undefined;
